import styled, { keyframes } from 'styled-components'
import { colors } from '../../../theme/Global'

const enterFromLeft = keyframes`
    from {
      transform: translateX(-100%);
    }
    to {
      transform: translateX(0);
    }
`

export const ToastContainer = styled.div`
  font-size: 14px;
  box-sizing: border-box;
  z-index: 999999
`

export const ToastButton = styled.button`
  position: relative;
  right: -.3em;
  top: -.3em;
  float: right;
  font-weight: 700;
  color: ${colors.white};
  outline: none;
  border: none;
  text-shadow: 0 1px 0 ${colors.white};
  opacity: .8;
  line-height: 1;
  font-size: 16px;
  padding: 0;
  cursor: pointer;
  background: 0 0;
  border: 0
`

export const ToastContent = styled.div`
  background: ${colors.white};
  transition: .3s ease;
  position: fixed;
  pointer-events: auto;
  overflow: hidden;
  margin: 0 0 6px;
  padding: 20px 15px 10px 10px;
  margin-bottom: 15px;
  height: 50px;
  width: 365px;
  max-height: 100px;
  border-radius: 3px 3px 3px 3px;
  box-shadow: 0 0 10px ${colors.mediumGrey};
  color: ${colors.white};
  opacity: .9;
  background-position: 15px;
  background-repeat: no-repeat;
  bottom: 12px;
  left: 12px;
  transition: transform .6s ease-in;
  animation: ${enterFromLeft} .7s;

  &:hover {
    box-shadow: 0 0 12px ${colors.white};
    opacity: 1;
    cursor: pointer
  }
`

export const ToastMessage = styled.p`
  margin: 0;
  text-align: left;
  height: 18px;
  margin-left: -1px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const ToastTitle = styled.p`
  font-weight: 700;
  font-size: 16px;
  text-align: left;
  margin-top: 0;
  margin-bottom: 6px;
  width: 300px;
  height: 18px;
`
